import Awards from "@/components/landing/aboutUs/Awards";
import Banner from "@/components/landing/aboutUs/Banner";
import CallToAction from "@/components/landing/aboutUs/CallToAction";
import Careers from "@/components/landing/aboutUs/Careers";
import GetStarted from "@/components/landing/aboutUs/GetStarted";
import OurMission from "@/components/landing/aboutUs/OurMission";
import TeamMember from "@/components/landing/aboutUs/TeamMember";

export default function AboutUs() {
  return (
    <main className="overflow-x-hidden">
      {/* Banner section */}
      <Banner />

      {/* GetStarted section */}
      <GetStarted />

      {/* Our Mission section */}
      <OurMission />

      {/* Call To Action section */}
      <CallToAction />

      {/* Team Member section */}
      <TeamMember />

      {/* Careers section */}
      <Careers />

      {/* Awards section */}
      <Awards />
    </main>
  );
}
